module.exports = __webpack_public_path__ + "static/media/terms.9cffcad6.xhtml";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/shared/ModalTerms/terms.xhtml
// module id = 450
// module chunks = 0 1 2 3 7 8 13 15 16 17 18 19 21 24 30